import { OnInit, EventEmitter, TemplateRef, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
var ModalDialogFocusDirective = /** @class */ (function () {
    function ModalDialogFocusDirective(searchInput) {
        this.searchInput = searchInput;
    }
    ModalDialogFocusDirective.prototype.ngOnInit = function () {
        this.searchInput.nativeElement.focus();
    };
    return ModalDialogFocusDirective;
}());
export { ModalDialogFocusDirective };
var ModalDialogComponent = /** @class */ (function () {
    /**
     * Creates an instance of ModalDialogComponent.
     * @param {NgbModal} modalService
     * @param {TranslateService} translate
     * @memberof ModalDialogComponent
     */
    function ModalDialogComponent(modalService, translate) {
        this.modalService = modalService;
        this.translate = translate;
        /**
         * True to display cancel button (default true)
         *
         * @memberof ModalDialogComponent
         */
        this.showCancel = true;
        /**
         * True to display positive button (default true)
         *
         * @memberof ModalDialogComponent
         */
        this.showPositive = true;
        /**
         * True to display negative button (default false)
         *
         * @memberof ModalDialogComponent
         */
        this.showNegative = false;
        /**
         * Show backdrop or not. Set `static` to make disable closing on click (default true)
         *
         * @memberof ModalDialogComponent
         */
        this.backdrop = true;
        /**
         * Set to 'large' or 'small' to resize, '' (empty) for default
         *
         * @memberof ModalDialogComponent
         */
        this.size = null;
        /**
         * Cancel event
         *
         * @memberof ModalDialogComponent
         */
        this.cancel = new EventEmitter();
        /**
         * Negative event
         *
         * @memberof ModalDialogComponent
         */
        this.negative = new EventEmitter();
        /**
         * Positive event
         *
         * @memberof ModalDialogComponent
         */
        this.positive = new EventEmitter();
        /**
         * After opening of dialog event
         *
         * @memberof ModalDialogComponent
         */
        this.afterOpen = new EventEmitter();
    }
    /**
     * init component
     *
     * @memberof ModalDialogComponent
     */
    ModalDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.validateSettings();
        if (!this.cancelButton) {
            this.translate.get('BTN_CANCEL').subscribe(function (val) { _this.cancelButton = val; });
        }
        if (!this.negativeButton) {
            this.translate.get('BTN_NO').subscribe(function (val) { _this.negativeButton = val; });
        }
        if (!this.positiveButton) {
            this.translate.get('BTN_OK').subscribe(function (val) { _this.positiveButton = val; });
        }
    };
    /**
     * Ensure required minimum is defined
     *
     * @private
     * @memberof ModalDialogComponent
     */
    ModalDialogComponent.prototype.validateSettings = function () {
        if (this.title === null || this.body === null) {
            throw new Error('Please provide title and body property on modal-dialog');
        }
        if (this.positive === null && this.negative === null) {
            throw new Error('Please provide positive or negative property on modal-dialog');
        }
    };
    /**
     * Run the dialog
     *
     * @param {*} content
     * @memberof ModalDialogComponent
     */
    ModalDialogComponent.prototype.openModal = function () {
        var _this = this;
        var options = { ariaLabelledBy: this.title, size: this.size, backdrop: this.backdrop };
        this._currentModal = this.modalService.open(this._content, options);
        this._currentModal.result.then(function (_) { return _this.onModalClose(); }, function (reason) { return _this.onModalDismiss(reason); });
        this.afterOpen.emit();
    };
    /**
     * Close the dialog
     * @param result
     */
    ModalDialogComponent.prototype.closeModal = function (result) {
        if (this._currentModal) {
            this._currentModal.close(result);
        }
    };
    /**
     * Handle positive
     *
     * @memberof ModalDialogComponent
     */
    ModalDialogComponent.prototype.onModalClose = function () {
        this.positive.emit();
    };
    /**
     * Handle dismiss (cancel or negative)
     *
     * @param {*} reason
     * @returns
     * @memberof ModalDialogComponent
     */
    ModalDialogComponent.prototype.onModalDismiss = function (reason) {
        switch (reason) {
            case 'cancel':
            case 0: // click into the wild
            case 1: // escape key
                return this.cancel.emit();
            case 'negative':
                return this.negative.emit();
            default:
                throw new Error('unknown dismiss reason: ' + reason);
        }
    };
    Object.defineProperty(ModalDialogComponent.prototype, "showFooter", {
        /**
         * return true if any button is displayed
         *
         * @readonly
         * @type {boolean}
         * @memberof ModalDialogComponent
         */
        get: function () {
            return this.showCancel || this.showPositive || this.showNegative;
        },
        enumerable: true,
        configurable: true
    });
    return ModalDialogComponent;
}());
export { ModalDialogComponent };
